<--业务员订单统计-->
<template>
    <div>
        <div style="padding:0 20px">
            <div class="top">
                <el-date-picker
                        v-model="date"
                        type="daterange"
                        align="right"
                        @change="dateChange"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions">
                </el-date-picker>
                <el-input
                        v-model="query.marketName"
                        placeholder="请输入业务姓名"
                        suffix-icon="el-icon-search"
                        style="width: 200px;"
                        size="small"  @change="getDate()" >

                </el-input>
                <el-button type="primary" @click="Export()" style="height: 30px">导出</el-button>
            </div>
            <el-table :data="list"
                      :header-cell-style="{'padding-left': '10%'}"
                      :cell-style="{'padding-left': '10%'}">
                <el-table-column prop="nickName" label="业务员"></el-table-column>
                <el-table-column prop="doctorCount" label="共计医生数量"></el-table-column>
                <el-table-column prop="count" label="下单医生数量"></el-table-column>
                <el-table-column prop="sumCount" label="订单数量"></el-table-column>
                <el-table-column prop="totalAmt" label="药品金额"></el-table-column>

            </el-table>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="query.pageNum"
                        :page-size="query.pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>

        </div>
    </div>
</template>

<script>
    import revert from "../common/revert";
    import getDate from "../common/dataFormat";
    export default {
        data() {
            return {
                list: [],
                authorization: localStorage.getItem('authorization'),
                date: '',
                pickerOptions: {
                    shortcuts: [{
                        text: '本周',
                        onClick(picker) {
                            const end = getDate.getCurrWeekDays().endtime;
                            const start = getDate.getCurrWeekDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '上周',
                        onClick(picker) {
                            const end = getDate.getLastWeekDays().endtime;
                            const start = getDate.getLastWeekDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '本月',
                        onClick(picker) {
                            const end = getDate.getCurrMonthDays().endtime;
                            const start = getDate.getCurrMonthDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '上月',
                        onClick(picker) {
                            const end = getDate.getLastMonthDays().endtime;
                            const start = getDate.getLastMonthDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                radioDate: '本周',
                handleDate: '',
                chartData: {
                    list:{
                        list:[]
                    }
                },
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 0,
                query: {
                    endTime: "",
                    startTime: "",
                    marketName:""
                }
            }
        },
        mounted() {

        },
        methods: {
        Export(){
            this.axios.post('/api-s/10009/100197/Export', this.query, {
                headers: {
                    Authorization: this.authorization
                }, responseType: "blob"
            }).then((response) => {
                    const BLOB = response.data;
                    const headers = response.headers
                    this.fileName = JSON.parse(JSON.stringify(headers));
                    let arr = this.fileName["content-type"].split(";");
                    this.fileName = arr[1];
                    let ar = this.fileName.split("=");
                    this.fileName = ar[1];
                    // Blob 对象表示一个不可变、原始数据的类文件对象（File 接口都是基于Blob）
                    const fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
                    fileReader.readAsDataURL(BLOB);
                    // 开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
                    fileReader.onload = (event) => {
                        // 处理load事件。该事件在读取操作完成时触发
                        // 新建个下载的a标签，完成后移除。
                        let a = document.createElement("a");
                        a.download = revert.revertUTF8(this.fileName)
                        a.href = event.target.result;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    };
                    this.ExportPageVisible = false;
                },
                (response) => {
                }
            )
        },

            getDate() {
                this.list=[]
                this.chartData = {}
                this.axios.post('/api-s/10009/100197', this.query, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    console.log(res)
                    if (res.data.code === 10000) {
                        if (res.data.data.length>0) {

                            this.chartData = res.data.data
                            this.total=this.chartData.length
                            let start = this.pageSize * (this.pageNum - 1)
                            let end = this.pageSize * this.pageNum
                            this.list = []
                            for (let i = start; i < end; i++) {
                                if (i < end) {
                                    if ( this.chartData[i]) {
                                        this.list.push( this.chartData[i])
                                    } else {
                                        break
                                    }
                                }
                            }

                        } else {
                            this.chartData = {}
                        }

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                let start = this.pageSize * (this.pageNum - 1)
                let end = this.pageSize * this.pageNum
                this.list = []
                for (let i = start; i < end; i++) {
                    if (i < end) {
                        if ( this.chartData[i]) {
                            this.list.push( this.chartData[i])
                        } else {
                            break
                        }
                    }
                }
            },
            dateChange(val) {
                this.query.startTime = val[0]
                this.query.endTime = val[1]
                this.getDate()
            }
        },
        created() {
            this.date = [
                getDate.getCurrWeekDays().starttime, getDate.getCurrWeekDays().endtime
            ]
            this.query.endTime = getDate.getCurrWeekDays().endtime;
            this.query.startTime = getDate.getCurrWeekDays().starttime;
            this.getDate()
        }
    }

</script>
<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-top: 13px;
        height: 52px;
    }

    .then {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        height: 112px;
        background: rgba(251, 254, 255, 1);
        border-radius: 4px;
        border: 1px solid rgba(210, 237, 255, 1);
        margin-bottom: 20px;
    }

    .then-in {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        height: 70px;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
    }

    .then-in-number {
        font-size: 30px;
        font-weight: bold;
        color: rgba(97, 167, 255, 1);
    }

    .line {
        width: 1px;
        height: 112px;
        background: rgba(210, 237, 255, 1);
    }

    .chart-box {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        padding: 30px 0;
        width: 100%;
        height: 423px;
        background: rgba(251, 254, 255, 1);
        border-radius: 8px;
        border: 1px solid rgba(210, 237, 255, 1);
        margin-bottom: 20px;
    }
</style>